import { Card } from '@abb-procure/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  effect,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { distinctUntilChanged } from 'rxjs';
import { SEARCH_TAB_TOOLTIPS } from '../../constants';
import { SearchState } from '../../store/search.state';
import { SearchDocumentResponseEntities } from '../../types/search-document-response-entities.type';
import { SearchFilters } from '../search-filters/search-filters.component';
import { SearchResults } from '../search-results/search-results.component';

type Entity = SearchDocumentResponseEntities | 'all';

@Component({
  selector: 'procure-search-overlay',
  templateUrl: './search-overlay.component.html',
  styleUrl: './search-overlay.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SearchResults,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatTooltip,
    Card,
    SearchFilters,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchOverlay {
  readonly activeEntityControl = new FormControl<Entity>('all');

  protected readonly isLoading = computed(() => this.state.isLoading());
  protected readonly tabs = computed(() => this.state.tabs());
  protected readonly hasSearchTerm = computed(() => this.state.hasSearchTerm());
  protected readonly tabTooltips = SEARCH_TAB_TOOLTIPS;

  private readonly state = inject(SearchState);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.activeEntityControl.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed())
      .subscribe((value) => {
        this.state.setActiveTab(value ?? 'all');
      });

    effect(() => {
      if (!this.state.searchTerm()) {
        this.activeEntityControl.setValue('all');
      }
    });

    this.destroyRef.onDestroy(() => {
      this.state.cleanState();
    });
  }
}
